import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HddTwoToneSvg from "@ant-design/icons-svg/es/asn/HddTwoTone";
import AntdIcon from "../components/AntdIcon";
var HddTwoTone = function HddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HddTwoTone.displayName = 'HddTwoTone';
}
export default /*#__PURE__*/React.forwardRef(HddTwoTone);